import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import PaymentStatusText from 'components/PaymentStatusText';
import { PaymentStatus_payment$key } from '__generated__/PaymentStatus_payment.graphql';

type Props = {
  payment: PaymentStatus_payment$key;
};

const PaymentStatus: FC<Props> = ({ payment }) => {
  const { status } = useFragment(
    graphql`
      fragment PaymentStatus_payment on Payment {
        status
      }
    `,
    payment
  );

  return <PaymentStatusText status={status} />;
};

export default PaymentStatus;
